<template>
  <div class="keyword-combination">
     <b-button
      @touchstart="showTooltip"
      @touchend="hideTooltip"
      @mousedown="showTooltip"
      @mouseleave="hideTooltip" 
      class="tooltip-button btn_check">
      <font-awesome-icon icon="info-circle" />&nbsp;{{ $t("how_to_use") }}
    </b-button>
    <div v-if="isTooltipVisible" class="tooltip-content">
      <span class="explanation_title" v-html="$t('explanation_title')"></span>
      <span class="explanation" v-html="$t('explanation')"></span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isTooltipVisible: false,
    };
  },
  methods: {
    showTooltip() {
      this.isTooltipVisible = true;
    },
    hideTooltip() {
      this.isTooltipVisible = false;
    }
  }
}

</script>